import classNames from "classnames";
import React from "react";

interface LoaderProps {
  size?: "s" | "m" | "l";
  theme?: "default" | "light" | "dark";
}

export const Loader: React.FC<LoaderProps> = ({
  size = "m",
  theme = "default",
}) => (
  <span
    className={classNames("loader", [
      size === "s" && "is-small",
      size === "l" && "is-large",
      `is-${theme}`,
    ])}
  />
);
